import CryptoJS from 'crypto-js';
import VueElementLoading from 'vue-element-loading'
import PageTracker from '../../../common/PageTrackerHelper'
import forwardAllocationComp from "./forwardallocation";
import ReverseAllocationComp from "./Reverseallocation";
import ReverseAllocationCompv2 from "./Reverseallocationv2/index.vue";
import ReverseAllOFP from "./ReverseAllOFP/index.vue";
import ReverseConfirmAllocation from "./ReverseConfirmAllocation/index.vue";
import { NewAllocationConfigFlag as NewAllocationFlag, 
    getHubDeliverySRListByHubID as getHubDeliverySRListByHubID, 
    getMissingRvpShipmentByHubID as getMissingRvpShipmentByHubID, 
    GetHubFlags1 as GetHubFlags2, 
    ServiceType as ServiceType1, 
    GetEscalation1 as GetEscalation, 
    GetClusterId as GetClusterIdList, 
    checkIsSVCAdhocVehiclesEnabled as isIsSVCAdhocVehiclesEnabled,
    fetchB2BShipmentsCounts as fetchB2BShipmentsCounts
} from '../../../../services/modules/newallocationservices.js';
import { EventBus } from '../../../main.js';
import keycloak from '../../../common/Keycloak';
import apiUrl from '../../../constants'

export default {
    name: 'newallocationpage',
    components: {
        VueElementLoading,
        'forward-allocation': forwardAllocationComp,
        'Reverse-allocation': ReverseAllocationComp,
        'Reverse-allocationv2': ReverseAllocationCompv2,
        'Reverse-allofp': ReverseAllOFP,
        'Reverse-confirmallocation': ReverseConfirmAllocation,
    },
    props: [],
    mixins: [PageTracker],
    data() {
        return {
            ActiveTabIndex: 0,
            IsRVP: true,
            IsDelivery: true,
            userDataKey: '',
            onOFFUsers: false,
            srArrayList: [],
            srList: [],
            rvpUserLoading:false,
            hyperVMsgData: null,
            layout: "half", // Options: 'half', 'first', 'second'
            Ismissingshipmentflag:true,
            CountLoading: false,
            progressCount: 0,
            userHubId: null,
            userid: null,

            /* optimize */
            hubCODPendingLimit: '',
            IsPendingCODBlock: false,
            isRSVSr: 0,
            ServiceLoader: false,
            ServiceTypeArrayList: [],
            ServiceTypeList: [],
            ClusterList: [],
            ClusterArrayList: [],
            loader: '<div class="velmld-spinner"><svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="20px" height="18px" viewBox="0 0 24 30" xml:space="preserve"><rect x="0" y="5.59869" width="4" height="19.8026" fill="#FF6700"><animate attributeName="height" attributeType="XML" values="5;21;5" begin="0s" dur="0.6s" repeatCount="indefinite"></animate> <animate attributeName="y" attributeType="XML" values="13; 5; 13" begin="0s" dur="0.6s" repeatCount="indefinite"></animate></rect> <rect x="10" y="9.59869" width="4" height="11.8026" fill="#FF6700"><animate attributeName="height" attributeType="XML" values="5;21;5" begin="0.15s" dur="0.6s" repeatCount="indefinite"></animate> <animate attributeName="y" attributeType="XML" values="13; 5; 13" begin="0.15s" dur="0.6s" repeatCount="indefinite"></animate></rect> <rect x="20" y="12.4013" width="4" height="6.19739" fill="#FF6700"><animate attributeName="height" attributeType="XML" values="5;21;5" begin="0.3s" dur="0.6s" repeatCount="indefinite"></animate> <animate attributeName="y" attributeType="XML" values="13; 5; 13" begin="0.3s" dur="0.6s" repeatCount="indefinite"></animate></rect></svg></div>',
            EscalationLoader: '',
            EscalationList: [],
            EscalationListArrayList: [],
            allocationrefreshflag: 0,
            isSVCEnabledForAdhocVehicles: false,
            isScannerOnlyAllocationEnabled: false,
            b2bPendingCount: 0,
            airshipmentscount: 0,
            WHIZshipmentcount: 0

        }
    },
    computed: {
        firstClass() {
            return this.layout === "first" ? "col-sm-12" : this.layout === "half" ? "col-sm-6" : "d-none";
          },
          secondClass() {
            return this.layout === "second" ? "col-sm-12" : this.layout === "half" ? "col-sm-6" : "d-none";
          },
    },
    async mounted() {
        this.userDataKey = window.localStorage.getItem('userUniqueKey');
        //this.userDataKey = 'Key';
        var userdetailEncrypt = window.localStorage.getItem('lmaccessuserdata')
        var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), this.userDataKey);
        var plaintext = bytes.toString(CryptoJS.enc.Utf8);
        var userdetail = JSON.parse(plaintext);
        this.username = userdetail.username;
        this.userid = userdetail.userid;
        this.userHubId = userdetail.hubdetails[0] == undefined ? 0 : userdetail.hubdetails[0]
        
        await this.GetHubFlags(this.userHubId);
        await this.GetDeliverySRList(this.userHubId);
        await this.getSVCAdhocVehicleFlag(this.userHubId);
        this.getB2BPendingCount();
        this.GetServiceTypeList();
        this.GetClusterIds();
        this.GetEscalation();
        this.GetNewAllocationFlags();
            //For RVP new Allcoation Flag
        // if (['43685', '42624'].includes(this.userid)) {
        //     this.onOFFUsers = true
        // } else {
        //     this.onOFFUsers = false
        // }
    },
    methods: {
        startLoading() {
            this.CountLoading = true
            this.progressCount = 0
      
            // Optional fake progress (or update from API)
            let interval = setInterval(() => {
              if (this.progressCount < 90) {
                this.progressCount += 10
              } else {
                clearInterval(interval)
              }
            }, 400)
          },
          stopLoading() {
            this.progressCount = 100
            setTimeout(() => {
              this.CountLoading = false
            }, 500)
          },
        show(which) {
            return this.layout === which || this.layout === "half";
        },
        expand(which) {
            this.layout = which;
        },
        collapse() {
            this.layout = "half";
        },
        SwitchTabs(Param){
            if(Param == 'RVP'){
                // this.GetDeliverySRList(this.userHubId)
                let hubidsArr = window.localStorage.getItem('missinghubids');
                let cacheArray = hubidsArr.split(",").map(Number); 
                if (this.Ismissingshipmentflag && !cacheArray.includes(Number(this.userHubId)) && ![9780,9003].includes(Number(this.userHubId))) {
                    this.GetMissingShippmentList(this.userHubId,this.Ismissingshipmentflag)
                }
            } else if (Param == 'OFP'){
                EventBus.$emit('refreshThirdPanel');
            }
        },
        GetNewAllocationFlags() {
            let Payload = { "hubid": this.userHubId }
            NewAllocationFlag(Payload, (result) => {
                if (result.data.code == 200) {
                    const { Deliveryflag, Rvpflag } = result.data.data;
                    let truthy = [undefined, 'undefined', true, 'true', null, "null"];

                    this.IsDelivery = truthy.includes(Deliveryflag);
                    this.IsRVP = truthy.includes(Rvpflag);
                    this.isScannerOnlyAllocationEnabled = result.data.isscannerallowed;

                    this.Ismissingshipmentflag = (result.data.syncMissingShipments) ? result.data.syncMissingShipments : false
                    
                    /* Refresh count and list FWD allocation Flag */
                    this.allocationrefreshflag = result.data.allocationrefreshflag;
                }
            })
        },
        GetDeliverySRList(hubid) {
            return new Promise((resolve, reject) => {
                try {
                    this.rvpUserLoading = true;
                    this.srArrayList = [];
                    this.srList = [];
                    let RVPPayload = {
                        "usertype": "3",
                        "hubid": [hubid],
                        "isCODApiCall": this.IsPendingCODBlock ? true : false,
                    }
                    getHubDeliverySRListByHubID(RVPPayload, (result) => {
                        try {
                            this.srArrayList = result.data.data.results;
                            for (var i = 0; i < this.srArrayList.length; i++) {
                                const srCODPendingAmt = this.srArrayList[i].codPendingAmount;
                                const isDayAllocationDone = this.srArrayList[i].IsDayAllocationDone;
                                let CodLimitBreachedFlag = !isDayAllocationDone && this.hubCODPendingLimit != null && srCODPendingAmt > 0 && srCODPendingAmt > this.hubCODPendingLimit;

                                this.srList.push({
                                    value: this.srArrayList[i].userid,
                                    text: `${this.srArrayList[i].FirstName} ${this.srArrayList[i].LastName} (${this.srArrayList[i].OldDeliveryUserOrUserId}) (${this.srArrayList[i].userid})`,
                                    OldUserid: this.srArrayList[i].OldDeliveryUserOrUserId,
                                    EmpType: this.srArrayList[i].EmpType,
                                    CourierCompanyID: this.srArrayList[i].CourierCompanyID,
                                    MobileNumber: this.srArrayList[i].MobileNumber,
                                    IsSRNeedTrip: this.srArrayList[i].isTripAllowedForSR,
                                    isCodLimitBreached: CodLimitBreachedFlag,
                                    codPendingAmt: srCODPendingAmt,
                                    isselfieverified: typeof(this.srArrayList[i].isselfieverified) != "undefined" ? this.srArrayList[i].isselfieverified : true,
                                    ishvonboardingdone: typeof(this.srArrayList[i].ishvonboardingdone) != "undefined" ? this.srArrayList[i].ishvonboardingdone : true,
                                })
                            }
                            
                            this.hyperVMsgData = {
                                hvOnboardingFailMsg: result.data.data.hvonboardingfailmsg,
                                hvSelieFailMsg: result.data.data.hvselfiefailmsg,
                            }
                            this.rvpUserLoading = false;
                        } catch (e) {
                            this.rvpUserLoading = false;
                            console.log('Error------', e);
                        }
                    })
                    resolve(true);
                } catch (err) {
                    this.rvpUserLoading = false;
                    console.log('Error Logs For GetDeliverySRList', err);
                    resolve(false);
                }
            })
        },

        GetMissingShippmentList() {
            return new Promise((resolve, reject) => {
                try {
                    let RVPPayload = { "hubId": parseInt(this.userHubId) }
                    getMissingRvpShipmentByHubID(RVPPayload, (result) => {
                        try {
                            if(result.data.code == 200){
                                
                                let hubids = window.localStorage.getItem('missinghubids');
                                // Step 1: Split it into an array (returns an array with one empty string element)
                                let arr = hubids ? hubids.split(",") : []; // This ensures it's an empty array if the string is truly empty

                                // Step 2: Modify the array (e.g., add an item)
                                arr.push(this.userHubId);

                                // Step 3: Convert it back to a string
                                let newStr = arr.join(",");
                                window.localStorage.setItem('missinghubids',newStr)
                                try {
                                    let TrackerInfo = {
                                        projectname: "Last Mile",
                                        type: "Web",
                                        routeurl: "websupport/handlemissingshipments",
                                        userid: this.userid,
                                        username: this.username,
                                        meta: {
                                            event: "websupport-handlemissingshipments",
                                            shipmentId: null,
                                            remarks: "FrontEnd",
                                            hubId: RVPPayload ? (RVPPayload.hubId ? RVPPayload.hubId : null) : null,
                                        },
                                    };
                                    this.PageTracker(TrackerInfo);
                                } catch (error) {
                                    console.log(error);
                                }
                                resolve(true)
                            }else{
                                resolve(false)
                            }
                        } catch (e) {
                            console.log('Error------', e);
                        }
                    })
                    resolve(true);
                } catch (error) {

                }
            })
        },
        redirectToExternalPortals(type = null) {
            if(!type) return true;
            if (keycloak.enableKavach) {
                if(type == 'priorityReport')
                    window.open(apiUrl.priorityreportredirect_url);
                if(type == 'b2bPortal')
                    window.open(`${apiUrl.b2bredirect_url}#/TripManagement`);
            }
        },
        GetHubFlags() {
            return new Promise((resolve, reject) => {
                let HubFlagsPayload = {
                    "Outsourceid": 4,
                    "hubid": this.userHubId
                }
                GetHubFlags2(HubFlagsPayload, (result) => {
                    if (result.data.data.code == 200) {
                        this.isRSVSr = result.data.data.data.IsRSVSr;
                        const hubCodLimit = result.data.data.data.configSetting.CODPendingLimit;
                        this.hubCODPendingLimit = (hubCodLimit && hubCodLimit != 0) ? hubCodLimit : null;
                        this.IsPendingCODBlock = result.data.data.data.configSetting.IsPendingCODBlock;
                    } else {
                        this.$alertify.error(result.data.data.message)
                    }
                    resolve(true);
                })
            })
        },
        GetServiceTypeList() {
            this.ServiceLoader = this.loader;
            let payload = {
                "serviceTypeValuesRequired": true
            }
            ServiceType1(payload, (result) => {
                this.ServiceTypeArrayList = result.data.data.serviceType;
                for (let i = 0; i < this.ServiceTypeArrayList.length; i++) {
                    this.ServiceTypeList.push({
                        text: `${this.ServiceTypeArrayList[i]}`
                    })
                }                
                this.ServiceLoader = '';
            })
        },
        GetClusterIds() {
            let payload = {
                "hubid": this.userHubId,
            }
            GetClusterIdList(payload, (result) => {
                this.ClusterArrayList = result.data.data;
                for (let i = 0; i < this.ClusterArrayList.length; i++) {
                    this.ClusterList.push({
                        value: this.ClusterArrayList[i].clusterId,
                        text: `${this.ClusterArrayList[i].clusterName}`,
                    })
                }
            })
        },
        GetEscalation() {
            this.EscalationLoader = this.loader;
            let payload = {}
            GetEscalation(payload, (result) => {
                this.EscalationListArrayList = result.data.data;
                for (let i = 0; i < this.EscalationListArrayList.length; i++) {
                    this.EscalationList.push({
                        text: `${this.EscalationListArrayList[i]}`
                    })
                }
                this.EscalationLoader = '';
            })
        },

        getSVCAdhocVehicleFlag(hubId) {
            return new Promise((resolve, reject) => {
                let payload = {
                    "hubId": hubId
                }
                isIsSVCAdhocVehiclesEnabled(payload, (result) => {
                    if (result.data.code == 200) {
                        this.isSVCEnabledForAdhocVehicles = (result.data.data && result.data.data.isAllowed) ? result.data.data.isAllowed : false;
                    }
                    resolve(true);
                })
            }) 
        },  
        
        getB2BPendingCount(){
            let payload = {
                "HubId": this.userHubId
            }
            fetchB2BShipmentsCounts(payload, (result) => {
                if (result.data.code == 200) {
                    this.b2bPendingCount = result.data.data.data.allocationpendingcount;
                }
            })
        },
        getAirShipmentCount(count){
            this.airshipmentscount = count;
        },
        getWHIZshipmentcount(count){
            this.WHIZshipmentcount = count;
        }
    }
}


// WEBPACK FOOTER //
// ./src/views/components/newallocationpagev2/newallocationpagev2.component.js